import { CircuitoResoData } from "./CircuitoResoData";
import { useState, useContext, useEffect } from "react";
import { PortalContext } from "../../../context/Provider";
import { setCircuitoTomo } from "../../../context/Actions/turnos/estudioTurnos";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import HeaderModal from "../headerModal/headerModal";
import "./Circuito.css";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../InputV1/InputV1";

const CircuitoTomo = ({
  titulo,
  dissmiss,
  danger,
  texto,
  completarFormulario,
  dataBioseguridad,
}) => {
  const { estudioTurnosDispatch } = useContext(PortalContext);
  // Toaster Global
  const { authState, toasterDispatch } = useContext(GlobalContext);
  // const [circuitoFiltrado, setCircuitoFiltrado] = useState(CircuitoResoData);

  const [circuitoFiltrado, setCircuitoFiltrado] = useState({
    contraste: null,
    peso: dataBioseguridad.peso ? dataBioseguridad.peso : null,
    renal: dataBioseguridad.flgInsuficienciaRenal?.toString() ?? null,
    labFuncionRenal: dataBioseguridad.flgLabFuncionRenal?.toString() ?? null,
    flgDiabetico: dataBioseguridad.flgDiabetico?.toString() ?? null,
    flgHipertenso: dataBioseguridad.flgHipertenso?.toString() ?? null,
    contrasteReciente: null,
    embarazo: null,
    amamantando: null,
  });

  const [camposObligatorios, setCamposObligatorios] = useState({});
  const [errores, setErrores] = useState([]);

  useEffect(() => {
    setCamposObligatorios({
      contraste: true,
      peso: true,
      renal: circuitoFiltrado.contraste === "1",
      labFuncionRenal: circuitoFiltrado.renal === "1",
      flgDiabetico: circuitoFiltrado.contraste === "1",
      flgHipertenso: circuitoFiltrado.contraste === "1",
      contrasteReciente: circuitoFiltrado.contraste === "1",
      embarazo:
        authState?.auth?.data?.paciente?.sexo === "F" &&
        circuitoFiltrado.contraste === "1",
      amamantando:
        authState?.auth?.data?.paciente?.sexo === "F" &&
        circuitoFiltrado.contraste === "1",
    });
  }, [circuitoFiltrado]);

  const onChangeRadio = (e) => {
    const { name, value } = e.target;
    setCircuitoFiltrado((prev) => {
      let updated = {
        ...prev,
        [name]: value, // ✅ guardamos boolean
      };

      // Si no tiene datos en la base reseteo los inputs dependientes
      if (dataBioseguridad === null || dataBioseguridad === "") {
        // lógica de reseteo de dependencias
        if (name === "contraste" && value === "2") {
          updated.renal = null;
          updated.labFuncionRenal = null;
          updated.flgDiabetico = null;
          updated.flgHipertenso = null;
        }
      }

      // Estos los reseteo siempre porque no son datos que vengan de la base
      if (name === "contraste" && value === "2") {
        updated.embarazo = null;
        updated.amamantando = null;
        updated.contrasteReciente = null;
      }

      return updated;
    });
    setErrores((prev) => prev.filter((campo) => campo !== name));
  };

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setCircuitoFiltrado((prev) => ({
      ...prev,
      [name]: parseInt(value) >= 0 ? parseInt(value) : "", // ✅ guardamos number o vacío
    }));
    setErrores((prev) => prev.filter((campo) => campo !== name));
  };

  const onClickVolverCirc = () => {
    setCircuitoFiltrado(CircuitoResoData);
    dissmiss();
  };

  const validarCampos = () => {
    const errores = [];

    Object.entries(camposObligatorios).forEach(([campo, esObligatorio]) => {
      if (esObligatorio) {
        const valor = circuitoFiltrado[campo];

        // ❌ chequeo de "vacío"
        if (
          valor === null ||
          valor === "" ||
          valor === undefined ||
          valor === "0" // si usás "0" como "sin respuesta"
        ) {
          errores.push(campo);
        }
      }
    });

    if (errores.length > 0) {
      setErrores(errores);
      return false;
    }

    return errores.length === 0;
  };

  const mapToBool = (value) => {
    if (value === "1") return true;
    if (value === "2") return false;
    return false;
  };

  const onClickBusqCirc = () => {
    if (validarCampos()) {
      const dto = {
        contraste: mapToBool(circuitoFiltrado.contraste),
        peso: circuitoFiltrado.peso,
        renal: mapToBool(circuitoFiltrado.renal),
        labFuncionRenal: mapToBool(circuitoFiltrado.labFuncionRenal),
        flgDiabetico: mapToBool(circuitoFiltrado.flgDiabetico),
        flgHipertenso: mapToBool(circuitoFiltrado.flgHipertenso),
        contrasteReciente: mapToBool(circuitoFiltrado.contrasteReciente),
        embarazo: mapToBool(circuitoFiltrado.embarazo),
        amamantando: mapToBool(circuitoFiltrado.amamantando),
      };
      setCircuitoTomo({
        ...dto,
        flgForm: true,
      })(estudioTurnosDispatch);
    } else {
      showToaster(
        {
          texto: "Complete las preguntas!",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} danger={danger} />
      <div className="ptur-circuitoTomo-bodyModal">
        <div className="ptur-circuito-tituloDesc">
          <p className="rb18l titulo-circuito">{texto}</p>
        </div>
        <div className="ptur-circuito-boxTomo">
          <div className="ptur-circuito-boxPreguntas">
            <p className="ptur-circuito-preguntaDesc rb14l">
              ¿La orden médica indica con contraste?{" "}
              {errores.includes("contraste") && (
                <span className="c-danger rb18b">*</span>
              )}
            </p>
            <div className="ptur-circuito-checkboxs">
              <span>
                <InputV1
                  id={"cont1"}
                  name={"contraste"}
                  onClick={onChangeRadio}
                  value={"1"}
                  inputType="check"
                  checkboxStr={"Sí"}
                  className={`fake-radio ptur-circuito-check ${
                    errores.includes("contraste") ? "input-error" : ""
                  }`}
                  noHeight={true}
                  checked={circuitoFiltrado.contraste === "1"}
                />
              </span>
              <span>
                <InputV1
                  id={"cont2"}
                  name={"contraste"}
                  onClick={onChangeRadio}
                  value={"2"}
                  inputType="check"
                  checkboxStr={"No"}
                  className={`fake-radio ptur-circuito-check ${
                    errores.includes("contraste") ? "input-error" : ""
                  }`}
                  noHeight={true}
                  checked={circuitoFiltrado.contraste === "2"}
                />
              </span>
            </div>
          </div>
          {circuitoFiltrado.contraste === "1" && (
            <div className="ptur-circuito-boxPreguntas">
              <p className="ptur-circuito-preguntaDesc rb14l">
                ¿Tiene insuficiencia renal?{" "}
                {errores.includes("renal") && (
                  <span className="c-danger rb18b">*</span>
                )}
              </p>
              <div className="ptur-circuito-checkboxs">
                <span>
                  <InputV1
                    id={"ren1"}
                    name={"renal"}
                    onClick={onChangeRadio}
                    value={"1"}
                    inputType="check"
                    checkboxStr={"Sí"}
                    className={`fake-radio ptur-circuito-check ${
                      errores.includes("renal") ? "input-error" : ""
                    }`}
                    noHeight={true}
                    checked={circuitoFiltrado.renal === "1"}
                  />
                </span>
                <span>
                  <InputV1
                    id={"ren2"}
                    name={"renal"}
                    onClick={onChangeRadio}
                    value={"2"}
                    inputType="check"
                    checkboxStr={"No"}
                    className={`fake-radio ptur-circuito-check ${
                      errores.includes("renal") ? "input-error" : ""
                    }`}
                    noHeight={true}
                    checked={circuitoFiltrado.renal === "2"}
                  />
                </span>
              </div>
            </div>
          )}
          {circuitoFiltrado.contraste === "1" &&
            circuitoFiltrado.renal === "1" && (
              <div className="ptur-circuito-boxPreguntas">
                <p className="ptur-circuito-preguntaDesc rb14l">
                  ¿Realizó un laboratorio de Función Renal en los últimos 30
                  días?{" "}
                  {errores.includes("labFuncionRenal") && (
                    <span className="c-danger rb18b">*</span>
                  )}
                </p>
                <div className="ptur-circuito-checkboxs">
                  <span>
                    <InputV1
                      id={"labFnRen1"}
                      name={"labFuncionRenal"}
                      onClick={onChangeRadio}
                      value={"1"}
                      inputType="check"
                      checkboxStr={"Sí"}
                      className={`fake-radio ptur-circuito-check ${
                        errores.includes("labFuncionRenal") ? "input-error" : ""
                      }`}
                      noHeight={true}
                      checked={circuitoFiltrado.labFuncionRenal === "1"}
                    />
                  </span>
                  <span>
                    <InputV1
                      id={"labFnRen2"}
                      name={"labFuncionRenal"}
                      onClick={onChangeRadio}
                      value={"2"}
                      inputType="check"
                      checkboxStr={"No"}
                      className={`fake-radio ptur-circuito-check ${
                        errores.includes("labFuncionRenal") ? "input-error" : ""
                      }`}
                      noHeight={true}
                      checked={circuitoFiltrado.labFuncionRenal === "2"}
                    />
                  </span>
                </div>
              </div>
            )}

          <div className="ptur-circuito-boxPreguntas">
            <p className="ptur-circuito-preguntaDesc rb14l">
              ¿Cuánto pesa?{" "}
              {errores.includes("peso") && (
                <span className="c-danger rb18b">*</span>
              )}
            </p>
            <div className="ptur-circuito-input">
              <input
                type="number"
                name={"peso"}
                onChange={(e) => onChangeInput(e)}
                value={circuitoFiltrado.peso}
                className={"ptur-input-peso inputNonScroll"}
                style={{
                  border:
                    errores.includes("peso") && "2px solid var(--color-danger)",
                }}
              />
              <p>kg</p>
            </div>
          </div>

          {circuitoFiltrado.contraste === "1" && (
            <>
              <div className="ptur-circuito-boxPreguntas">
                <p className="ptur-circuito-preguntaDesc rb14l">
                  ¿Usted es diabético?{" "}
                  {errores.includes("flgDiabetico") && (
                    <span className="c-danger rb18b">*</span>
                  )}
                </p>
                <div className="ptur-circuito-checkboxs">
                  <span>
                    <InputV1
                      id={"diab1"}
                      name={"flgDiabetico"}
                      onClick={onChangeRadio}
                      value={"1"}
                      inputType="check"
                      checkboxStr={"Sí"}
                      className={`fake-radio ptur-circuito-check ${
                        errores.includes("flgDiabetico") ? "input-error" : ""
                      }`}
                      noHeight={true}
                      checked={circuitoFiltrado.flgDiabetico === "1"}
                    />
                  </span>
                  <span>
                    <InputV1
                      id={"diab2"}
                      name={"flgDiabetico"}
                      onClick={onChangeRadio}
                      value={"2"}
                      inputType="check"
                      checkboxStr={"No"}
                      className={`fake-radio ptur-circuito-check ${
                        errores.includes("flgDiabetico") ? "input-error" : ""
                      }`}
                      noHeight={true}
                      checked={circuitoFiltrado.flgDiabetico === "2"}
                    />
                  </span>
                </div>
              </div>
              <div className="ptur-circuito-boxPreguntas">
                <p className="ptur-circuito-preguntaDesc rb14l">
                  ¿Usted es hipertenso?{" "}
                  {errores.includes("flgHipertenso") && (
                    <span className="c-danger rb18b">*</span>
                  )}
                </p>
                <div className="ptur-circuito-checkboxs">
                  <span>
                    <InputV1
                      id={"hiper1"}
                      name={"flgHipertenso"}
                      onClick={onChangeRadio}
                      value={"1"}
                      inputType="check"
                      checkboxStr={"Sí"}
                      className={`fake-radio ptur-circuito-check ${
                        errores.includes("flgHipertenso") ? "input-error" : ""
                      }`}
                      noHeight={true}
                      checked={circuitoFiltrado.flgHipertenso === "1"}
                    />
                  </span>
                  <span>
                    <InputV1
                      id={"hiper2"}
                      name={"flgHipertenso"}
                      onClick={onChangeRadio}
                      value={"2"}
                      inputType="check"
                      checkboxStr={"No"}
                      className={`fake-radio ptur-circuito-check ${
                        errores.includes("flgHipertenso") ? "input-error" : ""
                      }`}
                      noHeight={true}
                      checked={circuitoFiltrado.flgHipertenso === "2"}
                    />
                  </span>
                </div>
              </div>
            </>
          )}

          {authState?.auth?.data?.paciente?.sexo === "F" &&
            circuitoFiltrado.contraste === "1" && (
              <>
                <div className="ptur-circuito-boxPreguntas">
                  <p className="ptur-circuito-preguntaDesc rb14l">
                    ¿Usted está embarazada o tiene la sospecha de estarlo?{" "}
                    {errores.includes("embarazo") && (
                      <span className="c-danger rb18b">*</span>
                    )}
                  </p>
                  <div className="ptur-circuito-checkboxs">
                    <span>
                      <InputV1
                        id={"emb1"}
                        name={"embarazo"}
                        onClick={onChangeRadio}
                        value={"1"}
                        inputType="check"
                        checkboxStr={"Sí"}
                        className={`fake-radio ptur-circuito-check ${
                          errores.includes("embarazo") ? "input-error" : ""
                        }`}
                        noHeight={true}
                        checked={circuitoFiltrado?.embarazo === "1"}
                      />
                    </span>
                    <span>
                      <InputV1
                        id={"emb2"}
                        name={"embarazo"}
                        onClick={onChangeRadio}
                        value={"2"}
                        inputType="check"
                        checkboxStr={"No"}
                        className={`fake-radio ptur-circuito-check ${
                          errores.includes("embarazo") ? "input-error" : ""
                        }`}
                        noHeight={true}
                        checked={circuitoFiltrado?.embarazo === "2"}
                      />
                    </span>
                  </div>
                </div>
                <div className="ptur-circuito-boxPreguntas">
                  <p className="ptur-circuito-preguntaDesc rb14l">
                    ¿Usted está amamantando?{" "}
                    {errores.includes("amamantando") && (
                      <span className="c-danger rb18b">*</span>
                    )}
                  </p>
                  <div className="ptur-circuito-checkboxs">
                    <span>
                      <InputV1
                        id={"amam1"}
                        name={"amamantando"}
                        onClick={onChangeRadio}
                        value={"1"}
                        inputType="check"
                        checkboxStr={"Sí"}
                        className={`fake-radio ptur-circuito-check ${
                          errores.includes("amamantando") ? "input-error" : ""
                        }`}
                        noHeight={true}
                        checked={circuitoFiltrado?.amamantando === "1"}
                      />
                    </span>
                    <span>
                      <InputV1
                        id={"amam2"}
                        name={"amamantando"}
                        onClick={onChangeRadio}
                        value={"2"}
                        inputType="check"
                        checkboxStr={"No"}
                        className={`fake-radio ptur-circuito-check ${
                          errores.includes("amamantando") ? "input-error" : ""
                        }`}
                        noHeight={true}
                        checked={circuitoFiltrado?.amamantando === "2"}
                      />
                    </span>
                  </div>
                </div>
              </>
            )}
          {circuitoFiltrado.contraste === "1" && (
            <div className="ptur-circuito-boxPreguntas">
              <p className="ptur-circuito-preguntaDesc rb14l">
                ¿Se realizó en las últimas 72hs. algún otro estudio con
                contraste (resonancia, cámara gamma, etc)?{" "}
                {errores.includes("contrasteReciente") && (
                  <span className="c-danger rb18b">*</span>
                )}
              </p>
              <div className="ptur-circuito-checkboxs">
                <span>
                  <InputV1
                    id={"contRec1"}
                    name={"contrasteReciente"}
                    onClick={onChangeRadio}
                    value={"1"}
                    inputType="check"
                    checkboxStr={"Sí"}
                    className={`fake-radio ptur-circuito-check ${
                      errores.includes("contrasteReciente") ? "input-error" : ""
                    }`}
                    noHeight={true}
                    checked={circuitoFiltrado.contrasteReciente === "1"}
                  />
                </span>
                <span>
                  <InputV1
                    id={"contRec2"}
                    name={"contrasteReciente"}
                    onClick={onChangeRadio}
                    value={"2"}
                    inputType="check"
                    checkboxStr={"No"}
                    className={`fake-radio ptur-circuito-check ${
                      errores.includes("contrasteReciente") ? "input-error" : ""
                    }`}
                    noHeight={true}
                    checked={circuitoFiltrado.contrasteReciente === "2"}
                  />
                </span>
              </div>
            </div>
          )}
        </div>
        <div className="ptur-circuito-boxBtn">
          <button
            className="ptur-circuito-btnVolver c-latex30 rb16m"
            onClick={onClickVolverCirc}
          >
            Volver
          </button>
          <button
            className="ptur-circuito-btnBusq c-white rb16m"
            onClick={onClickBusqCirc}
          >
            Buscar turnos
          </button>
        </div>
      </div>
    </>
  );
};

export default CircuitoTomo;
